import { FC, useEffect, useRef } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import MainLayout from 'components/main-layout/MainLayout';
import Loader from 'components/Loader';
import { useModal } from 'store/modal';
import { getArchiveDownloadLink } from 'utils/helpers/archives';

const DownloadArchivePage: FC = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const { t } = useTranslation();
  const { showModal } = useModal();
  const hasDownloadedRef = useRef(false);

  useEffect(() => {
    if (hasDownloadedRef.current) return;
    hasDownloadedRef.current = true;

    const downloadArchive = async () => {
      try {
        const archiveId = parseInt(id, 10);

        if (Number.isNaN(archiveId)) {
          showModal({
            type: 'error',
            content: t('archives.invalidArchiveId'),
          });
          history.push('/archives');
          return;
        }

        const downloadLink = await getArchiveDownloadLink(archiveId);

        window.location.href = downloadLink;

        setTimeout(() => {
          history.push('/archives');
        }, 2000);
      } catch (error) {
        showModal({
          type: 'error',
          content: t('archives.downloadError'),
        });
        history.push('/archives');
      }
    };

    downloadArchive();
  }, [id, history, t, showModal]);

  return (
    <MainLayout title={t('archives.downloading')}>
      <ContentWrapper>
        <LoaderWrapper>
          <Loader size="large" />
          <Message>{t('archives.preparingDownload')}</Message>
        </LoaderWrapper>
      </ContentWrapper>
    </MainLayout>
  );
};

export default DownloadArchivePage;

const ContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
`;

const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

const Message = styled.p`
  font-size: 16px;
  color: #666;
`;
